<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="46"
    height="10"
    viewBox="0 0 46 10"
    fill="none"
    >
    <circle cx="5" cy="5" r="5" fill="#2A2C2C">
      <animate
        attributeName="opacity"
        values="0.4;1;0.4"
        dur="1.2s"
        begin="0s"
        repeatCount="indefinite"
      />
    </circle>
    <circle cx="23" cy="5" r="5" fill="#2A2C2C">
      <animate
        attributeName="opacity"
        values="0.4;1;0.4"
        dur="1.2s"
        begin="0.2s"
        repeatCount="indefinite"
      />
    </circle>
    <circle cx="41" cy="5" r="5" fill="#2A2C2C">
      <animate
        attributeName="opacity"
        values="0.4;1;0.4"
        dur="1.2s"
        begin="0.4s"
        repeatCount="indefinite"
      />
    </circle>
  </svg>
</template>
